<section class="auth-page">
  <div class="auth-card ecb-card">
    <div class="auth-visual">
      <a routerLink="/" class="ecb-logo">
        <span class="ecb-logo-mark">ECB</span>
        <span class="ecb-logo-text">
          <span>ECB</span>
          <small>TRAINING SERVICES</small>
        </span>
      </a>

      <h1>Admin Login</h1>
      <p>Manage courses, customers, orders and training content.</p>

      <div class="auth-badge">
        <i class="fa fa-lock"></i>
        <span>Secure training portal access</span>
      </div>
    </div>

    <div class="auth-form">
      <h2>Admin Login</h2>
      <p class="ecb-muted">Use your ECB Training admin account credentials.</p>

      <!-- Error Message -->
      <div class="login-error-box" *ngIf="errorMessage">
        <i class="fa fa-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <label>Email Address</label>
      <input class="ecb-form-control" [(ngModel)]="email" placeholder="admin&#64;ecbtraining.local"
        [class.input-error]="errorMessage" (input)="clearError()" (keyup.enter)="login()">

      <label>Password</label>
      <input class="ecb-form-control" type="password" [(ngModel)]="password" placeholder="Enter password"
        [class.input-error]="errorMessage" (input)="clearError()" (keyup.enter)="login()">

      <button type="button" class="ecb-btn-primary w-100 mt-3" [disabled]="isLoading" (click)="login()">

        <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-sign-in'"></i>
        {{ isLoading ? 'Logging in...' : 'Login' }}
      </button>

      <a routerLink="/course-qualifications" class="register-link">Back to public courses</a>
    </div>
  </div>
</section>